import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { PaymentPreviewV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const MakePaymentPaymentInformationApiActions = createActionGroup({
  source: 'Make Payment - Payment Information API',
  events: {
    'Payment Preview Updated': props<{ payload: PaymentPreviewV1Response }>(),
    'Payment Preview Update Error': props<{ error: HttpErrorResponse }>(),
  },
});
